import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import IdpConfigs from './pages/IdpConfigs';
import Policies from './pages/Policies';
import MigrationStatus from './pages/MigrationStatus';
import AuditLogs from './pages/AuditLogs';
import Profile from './pages/Profile';
import Team from './pages/Team';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/config/idps" replace />} />
            <Route path="config/idps" element={<IdpConfigs />} />
            <Route path="config/policies" element={<Policies />} />
            <Route path="audit/status" element={<MigrationStatus />} />
            <Route path="audit/logs" element={<AuditLogs />} />
            <Route path="profile" element={<Profile />} />
            <Route path="team" element={<Team />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
